import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import axios from "axios";
import {apiUrl, apiUrl2} from "../../config/config";
import "./topnav.css";
import { Toaster } from "react-hot-toast";
class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profileLink: "/dist/img/user1.png",
    };
  }

  componentDidMount() {
    if (this.props.auth.user.profileImage) {
      this.setState({
        profileLink:
          "https://web.mybiocalculus.com/assets/profile_image/users/" +
          this.props.auth.user.profileImage,
      });
    }
  }

  async onLogoutClick(e) {
    e.preventDefault();

    const verifierId = (localStorage.getItem("verifierid") || "").trim();
    const loginedTime = (localStorage.getItem("loginedDateTime") || "").trim();
    const validId = verifierId && verifierId !== "null" && verifierId !== "undefined";
    const validTime = loginedTime && loginedTime !== "null" && loginedTime !== "undefined";

    try {
      if (validId && validTime) {
        await axios.post(
          `${apiUrl}api/users/updateLogoutTime`,
          {
            Verifier_id: verifierId,
            LoginedTime: loginedTime,
          }
        );

        const activityPct = Number(localStorage.getItem("activityPercentage"));
        const breakTime = Number(localStorage.getItem("breakTime"));
        await axios.post(
          `${apiUrl}api/users/UpdateVerifierActivity`,
          {
            Verifier_id: verifierId,
            LoginedTime: loginedTime,
            ActivityLevel: Number.isFinite(activityPct) ? Math.round(activityPct) : 0,
            BreaksConsumed: Number.isFinite(breakTime) ? Math.round(breakTime) : 0,
          }
        );
      }

      this.props.logoutUser();
      window.location.href = "/login";
    } catch (err) {
      console.error("Error during logout:", err);
    }
  }

  render() {
    return (
      <>
        <nav className="navbar navbar-inverse navbar-fixed-top">
          {/* Add the Toaster component */}
          <Toaster position="top-center" />
          <div className="mobile-only-brand pull-left">
            <div className="nav-header pull-left">
              <div className="logo-wrap">
                <a href="#">
                  <img
                    className="brand-img"
                    id="login_logo"
                    src="/dist/img/logo.png"
                    alt="brand"
                  />
                  <span className="brand-text">Biocalculus</span>
                </a>
              </div>
            </div>
            {localStorage.getItem("verifiertype") != "7" && (
              <a
                id="toggle_nav_btn"
                className="toggle-left-nav-btn inline-block ml-20 pull-left"
                href="#"
              >
                <i className="zmdi zmdi-menu"></i>
              </a>
            )}
          </div>
          <div id="mobile_only_nav" className="mobile-only-nav pull-right">
            <ul className="nav navbar-right top-nav pull-right">
              <li className="dropdown auth-drp">
                <a
                  href="#"
                  className="dropdown-toggle pr-0"
                  data-toggle="dropdown"
                >
                  <img
                    src={this.state.profileLink}
                    alt="user_auth"
                    className="user-auth-img img-circle"
                  />
                  <span className="user-online-status"></span>
                </a>
                <ul
                  className="dropdown-menu user-auth-dropdown"
                  data-dropdown-in="flipInX"
                  data-dropdown-out="flipOutX"
                >
                  <li>
                    <a href={this.props.profileLink}>
                      <i className="zmdi zmdi-account"></i>
                      <span>Profile</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={this.onLogoutClick.bind(this)}>
                      <i className="zmdi zmdi-power"></i>
                      <span>Log Out</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  }
}

TopNav.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(TopNav);
